export const SHOULD_SHOW_MODAL_STORAGE_KEY = 'eGabinet:showShowMfaRequiredModal';
